import * as React from 'react';
import { Table, Button, TabContent } from 'reactstrap';
import { DownArrow, UpArrow } from '../../components/Icons';
const iconStyles = require('../../components/icons.css');
const tableStyles = require('./partyMapping.css');
export const PartyActivationTable = ({ tableData }) => {
  const {
    state,
    getTableProps,
    headerGroups,
    getTableBodyProps,
    rows,
    prepareRow,
    pageOptions,
    page,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = tableData;

  const pageIndex = state.pageIndex;
  return (
    <div className={tableStyles.fullHeight}>
      <div className={tableStyles.fullHeightTableContainer}>
        <div className={tableStyles.fitContentTableContainer}>
          <Table
            {...getTableProps()}
            striped
            className={tableStyles.artistMappingTable}
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      {column.render('Header')}
                      <div>
                        {column.canFilter ? column.render('Filter') : null}
                      </div>
                      <Button
                        size="sm"
                        color="link"
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.isSorted ? 'sorted ' : 'sort'}
                        <span>
                          {column.isSorted ? (
                            column.isSortedDesc ? (
                              <DownArrow
                                fill="#007bff"
                                class={iconStyles.sortButton}
                              />
                            ) : (
                              <UpArrow
                                fill="#007bff"
                                class={iconStyles.sortButton}
                              />
                            )
                          ) : (
                            ''
                          )}
                        </span>
                      </Button>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        <div className={tableStyles.pagination}>
          <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
            Previous Page
          </Button>
          <Button onClick={() => nextPage()} disabled={!canNextPage}>
            Next Page
          </Button>
          <div>
            Page{' '}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
        </div>
        Total Rows: {rows.length}
      </div>
    </div>
  );
};
